import styles from './StatsStrip.module.css';
import { SectionWrapper } from '../shared/SectionWrapper';

const stats = [
  { value: '500k+', label: 'COUPLES PLAYING' },
  { value: '12M', label: 'FANTASIES MATCHED' },
  { value: '7', label: 'QUIZZES / 7 STORIES' },
  { value: '4.8★', label: 'APP STORE RATING', hideMobile: true },
  { value: '0', label: 'DATA SOLD. EVER.' },
];

export function StatsStrip() {
  return (
    <SectionWrapper className={styles.section}>
      <div className={styles.strip}>
        {stats.map((s) => (
          <div key={s.label} className={`${styles.stat} ${s.hideMobile ? styles.hideOnMobile : ''}`}>
            <div className={styles.value}>{s.value}</div>
            <div className={styles.label}>{s.label}</div>
          </div>
        ))}
      </div>
    </SectionWrapper>
  );
}
